
import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
// import Breadcrumb from "../components/Breadcrumb";
import Layer from "../components/TestimonialsListLayer";

const TestimonialsListPage = () => {
  return (
    <>
      <MasterLayout>
        {/* <Breadcrumb title="Testimonials Management" /> */}
        <Layer />
      </MasterLayout>
    </>
  );
};
export default TestimonialsListPage;
